import { render, staticRenderFns } from "./ThgDescriptionSvgAgency.vue?vue&type=template&id=08c3f04f"
import script from "./ThgDescriptionSvgAgency.vue?vue&type=script&lang=ts"
export * from "./ThgDescriptionSvgAgency.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports